import template from './registration-disabled.html';

export default class SelfRegistrationDisabledComponent {
  constructor() {
    this.template = template;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/registration/components/self-registration/registration-disabled/registration-disabled-component.js